import { Component, OnInit } from "@angular/core";
import {
  NotificationService,
  CertificateListService,
  DateFormatService,
  NotificationKeys,
  ResponseStatus,
} from "@core";
import { TranslateService } from "@ngx-translate/core";
import endOfMonth from "date-fns/endOfMonth";
import { BalanceService } from "src/app/core/services/wallet/balance.service";

@Component({
  selector: "app-notifications",
  templateUrl: "./notifications.component.html",
  styleUrls: ["./notifications.component.less"],
  standalone: false,
})
export class NotificationsComponent implements OnInit {
  loading: boolean = true;
  notifications: any[] = [];
  today = new Date();
  notificationsId: any[] = [];

  notificationsSelection: any[] = [];
  checked = false;
  indeterminate = false;
  listOfCurrentPageData: any[] = [];
  listOfData: any[] = [];
  setOfCheckedId = new Set<number>();

  //PAGINATION
  current_page: number = 0;
  total: number = 0;
  from: number = 0;
  to: number = 0;
  lastpage: number = 0;
  page: any[] = [];
  meta: any;
  nextPage: string = "";
  previousPage: string = "";

  ranges = {
    Today: [new Date(), new Date()],
    "This Month": [new Date(), endOfMonth(new Date())],
  };

  constructor(
    private notify: NotificationService,
    private certificateService: CertificateListService,
    private walletBalance: BalanceService,
    private translate: TranslateService,
    private dateFormat: DateFormatService,
  ) {}

  ngOnInit(): void {
    this.loadNotifications();
  }

  //TABLE METHODS
  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }

  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }

  onAllChecked(value: boolean): void {
    this.listOfCurrentPageData.forEach((item) =>
      this.updateCheckedSet(item.id, value),
    );
    this.refreshCheckedStatus();
  }

  onCurrentPageDataChange($event: any[]): void {
    this.listOfCurrentPageData = $event;
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every((item) =>
      this.setOfCheckedId.has(item.id),
    );
    this.indeterminate =
      this.listOfCurrentPageData.some((item) =>
        this.setOfCheckedId.has(item.id),
      ) && !this.checked;
  }

  loadNotifications() {
    this.loading = true;
    this.certificateService

      .notificationHistory()
      .then((res) => {
        this.notifications = res?.data?.data;
        this.markallAsread();
        this.meta = res?.data?.path;
        this.current_page = res?.data?.current_page;
        this.lastpage = res?.data?.last_page_url;
        this.from = res?.data?.from;
        this.to = res?.data?.to;
        this.total = res?.data?.total;
        this.nextPage = res?.data?.next_page_url;
        this.loading = false;
      })
      .catch((err) => {
        console.warn(err);
        this.loading = false;
      });
  }

  next(id: string) {
    this.loading = true;
    let url = "?page_size=15&page=" + id;
    this.certificateService
      .nextLogs(url)
      .then((res) => {
        this.loading = false;
        if (res.error) {
          this.walletBalance.sendBalance("false");
          return;
        }

        this.notifications = res.data.data;
        this.meta = res.data.path;
        this.current_page = res.data.current_page;
        this.lastpage = res.data.last_page;
        this.from = res.data.from;
        this.to = res.data.to;
        this.total = res.data.total;
        this.nextPage = res.data.next_page_url;
      })
      .catch((err) => {
        this.loading = false;
        console.warn(err);
      });
  }
  markAsread() {
    let arr = Array.from(this.setOfCheckedId);
    if (arr.length == 0) {
      return;
    }
    this.loading = true;

    let body = {
      id: String(arr[0]),
    };
    this.loading = true;
    this.certificateService
      .markNotification(body)
      .then((res) => {
        this.loading = false;
        if (res.error) {
          this.notify.error("", res.error, NotificationKeys.NOTIFICATION);
          return;
        }
        this.notify.success("", res.message, NotificationKeys.NOTIFICATION);
        this.setOfCheckedId = new Set<number>();
        this.loadNotifications();
      })
      .catch((err) => {
        console.error(err?.error?.message);
        this.loading = false;
      });
  }
  markallAsread() {
    this.loading = true;
    this.notifications?.forEach((i) => {
      this.notificationsId.push({ id: i?.id });
    });
    this.certificateService
      .markNotification(this.notificationsId)
      .then((res) => {
        this.loading = false;
        if (res?.error) {
          this.notify.error("", res?.error, NotificationKeys.NOTIFICATION);
          return;
        }
        this.notificationsId = [];
      })
      .catch((err: any) => {
        console.error(err?.error?.message);
        this.loading = false;
      });
  }

  grantConsent(status: string, id: string) {
    this.loading = true;
    let body = {
      status: status,
      id: id,
    };
    this.certificateService
      .acceptRejectConsent(body)
      .then((res) => {
        if (res.status === ResponseStatus.FAILED) {
          this.loading = false;
          this.notify.error(
            this.translate.instant("GENERAL.DENIED"),
            res.message,
          );
          return;
        }
        this.notify.success(
          this.translate.instant("GENERAL.APPROVED"),
          res.message,
        );
        this.loadNotifications();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }
}
